import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

/**
 * Redirect a new user to the user dash or the trial event dash
 *
 * @param {*} param0
 */
const NewSignupRedirectContainer = ({ isTeamAdmin, user, history }) => {
  useEffect(() => {
    if (isTeamAdmin === false) {
      history.replace(`/dash/user`);
      return;
    }

    if (isTeamAdmin && user) {
      const userTeamId = user.teams[0].team;
      const userEventId = user.events && user.events[0].event;

      const redirectPath = `/dash/team/${userTeamId}/event/${userEventId}/dashboard`;
      history.replace(redirectPath);
    }
  }, [history, isTeamAdmin, user]);

  return <span />;
};

NewSignupRedirectContainer.propTypes = {
  isTeamAdmin: PropTypes.bool,
  user: PropTypes.object,
  history: PropTypes.object
};

export default withRouter(
  connect(state => {
    const { isTeamAdmin, user } = state;
    return { isTeamAdmin, user };
  })(NewSignupRedirectContainer)
);
